/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
import React, { useEffect } from "react";
import styles from "./styles.m.css";
import { DfpAd } from "../../../atoms/dfp-ad";
import wretch from "wretch";
import Media from "react-media";

const StoryPageStatic = () => {
  useEffect(() => {
    wretch("https://ping.vikatan.com/?userid=609020&aid=1245")
      .get()
      .json(response => console.log(response));
  });

  function handleClick(params) {
    const staticData = {
      data: {
        vikatan: {
          cookie: "46a7f43f-a99e-35e3-ad1e-b65c2300ed9f",

          customer: {
            userId: "826969",

            username: "Ismail",

            userType: "P",

            userEmail: "ismail@vikatan.com",

            userJoinDate: "2020-08-12 12:48:55",

            metypeJWT:
              "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImJyaXlhbm5hNjZAbGl0ZXJtc3NiLmNvbSIsIm5hbWUiOiJVbm5hbWVkIFVzZXIiLCJtZW1iZXItaWQiOiIyMDcxNjg3IiwiaWF0IjoxNTk3MjQwODY5fQ.qZ3-JchkJM4s54-1Qr7NuoKnW8p-p_DdBP1obU7oKhg",

            loggedIn: true
          }
        },

        event: {
          type: params,

          timestamp: 279,

          localtime: {
            utcoffset: 330,

            date: "2020-08-12"
          },

          collectedData: {},

          pianoCollectedData: {}
        },

        user: {
          device: {
            browserua: {
              general: {
                dnt: false
              }
            },

            screen: {
              width: 360,

              height: 640,

              availwidth: 360,

              availheight: 640,

              orientation: "portrait-primary"
            }
          },

          id: {
            session: "ckdrfz6l2213s7q4k18",

            firstparty: "ckdqwofhp0o3b7mgr08"
          },

          consents: {
            gdpr: true
          }
        },

        page: {
          loadtime: 1388,

          title:
            "Corona Virus: தமிழகத்தில் 3.14 லட்சத்தைக் கடந்த பாதிப்பு! - புதிதாக 5,871 பேருக்குத் தொற்று! #NowAtVikatan\t | 12-08-2020  just in live updates",

          protocol: "https:",

          host: "www.vikatan.com",

          hostname: "www.vikatan.com",

          port: "",

          href: "https://www.vikatan.com/news/general-news/12-08-2020-just-in-live-updates",

          search: "",

          hash: "",

          path: "/news/general-news/12-08-2020-just-in-live-updates",

          domain: "vikatan.com"
        },

        referrer: {},

        session: {
          eventseq: 8,

          status: "active",

          id: "0d9deef8-cc27-4723-9314-4e9b1c0994a6",

          lastvisitedpage: {
            loadtime: 1388,

            title:
              "Corona Virus: தமிழகத்தில் 3.14 லட்சத்தைக் கடந்த பாதிப்பு! - புதிதாக 5,871 பேருக்குத் தொற்று! #NowAtVikatan\t | 12-08-2020  just in live updates",

            protocol: "https:",

            host: "www.vikatan.com",

            hostname: "www.vikatan.com",

            port: "",

            href: "https://www.vikatan.com/news/general-news/12-08-2020-just-in-live-updates",

            search: "",

            hash: "",

            path: "/news/general-news/12-08-2020-just-in-live-updates",

            domain: "vikatan.com"
          },

          referrer: {}
        },

        dmascript: {
          version: "3.0.287",

          releasedate: "2020-08-10",

          dntignore: true
        }
      },

      getEventTime: {
        field: ["event", "timestamp"],

        sub: 1
      },

      addDeviceHeaders: ["user", "device", "headers"],

      addRemoteAddress: ["user", "id", "ip"],

      tran: [
        {
          dateSplit: {
            fromField: ["event", "timestamp"],

            toField: ["event", "localtime"],

            parts: ["date", "hour", "minute", "weekday", "weekdayno", "utcoffset", "week"],

            utcoffset: ["event", "localtime", "utcoffset"]
          }
        },
        {
          compact: {}
        }
      ],

      enrich: [
        {
          ip2location: {
            fromField: "user.id.ip",

            toField: "user.location"
          }
        },
        {
          detectDevice: {
            fromField: "user.device.headers",

            toField: "user.device",

            mode: "merge"
          }
        }
      ],

      addCookie: {
        field: ["user", "id", "deepcookie"],
        set: 0
      }
    };

    wretch("https://ping.vikatan.com/?userid=826969&aid=1245")
      .post(staticData)
      .json(response => console.log(response));
  }

  return (
    <div>
      <div>
        <Media query="(min-width:768px)">
          <DfpAd adtype="test_728x90" placement="all" />
        </Media>
      </div>
      <div className={`main-page ${styles["main"]}`}>
        <div />
        <div className={"main-content"}>
          <div className={`container ${styles["story-grid"]}`}>
            <div className={`${styles["story-header"]}`}>
              <h1 className="styles-m__headline__1uXyt">
                ```தளபதி'யாக ஓ.கே... தலைவராக எப்படி?'' - ` தலைவர்' ஸ்டாலினின் ஓராண்டு
              </h1>
              <DfpAd adtype="test_320x50" placement="all" />
              <ul>
                <li>
                  <button onClick={() => handleClick("Event 1")}>Buton 1</button>
                </li>
                <li>
                  <button onClick={() => handleClick("Event 2")}>Buton 2</button>
                </li>
                <li>
                  <button onClick={() => handleClick("Event 3")}>Buton 3</button>
                </li>
                <li>
                  <button onClick={() => handleClick("Event 4")}>Buton 4</button>
                </li>
              </ul>
              <p className="sub-headline">
                'தளபதி' என்றே கோஷமிட்டுப் பழகிய தி.மு.க உடன்பிறப்புகள், கருணாநிதி உடல் அருகே கலகத்துடன் நின்ற ஸ்டாலினை
                நோக்கி "தலைவரே” என்று உரக்கக் கோஷமிட்டது அப்போதுதான்.{" "}
              </p>

              <img
                src={
                  "https://images.assettype.com/vikatan%2F2019-08%2F64d273dc-7938-49ed-8acf-8d23d25e08e3%2Fsf5d4mcg_mk_stalin__dmk_625x300_28_November_18.webp?rect=0%2C34%2C650%2C366&w=700&auto=format%2Ccompress"
                }
              />
              <p>
                'ஆகஸ்ட் 8-ம் தேதி கருணாநிதியின் உடலை மெரினாவில் புதைக்கத் தடையில்லை' என்று நீதிமன்றம் உத்தரவு பிறப்பித்த
                நேரம், கருணாநிதி உடல் அருகே நின்ற ஸ்டாலின் கதறி அழுதார். அந்தக் கண்ணீருக்குப் பின்னால் ஒரு மகனுக்கான
                பாசம் மட்டுமன்றி ஒரு தலைவருக்கான கம்பீரமும் கலந்திருந்தது. `தளபதி' என்றே கோஷமிட்டுப் பழகிய தி.மு.க
                உடன்பிறப்புகள், கருணாநிதி உடல் அருகே கண்ணீரோடு நின்ற ஸ்டாலினை நோக்கி "தலைவரே” என்று உரக்கக்கோஷமிட்டது
                அப்போதுதான். தளபதியாக 40 ஆண்டுகளுக்கும் மேல் பவனி வந்த ஸ்டாலின் தி.மு.க-வின் 'தலைவர்' என்ற அரியாசனத்தில்
                அமர்ந்து இன்றோடு ஓராண்டு நிறைவு பெறுகிறது.
              </p>
              <DfpAd adtype="test_300x250_2" placement="all" />
              <p>
                தி.மு.க-வின் தலைவராக 50 ஆண்டுகளாகக் கோலோச்சிய கருணாநிதியின் மறைவுக்குப் பிறகு, ஆகஸ்ட் 28-ம் தேதி
                அறிவாலயத்தில் நடைபெற்ற பொதுக்குழுவில் தி.மு.க-வின் தலைவராக முடிசூடினார் மு.க.ஸ்டாலின். 1976-ம் ஆண்டு
                மிசாவில் கைது செய்யப்பட்ட பிறகு, பல்வேறு பொறுப்புகளை தி.மு.க-வில் ஏற்று கருணாநிதி உயிருடன் இருக்கும் வரை
                அவரின் நிழலாக இருந்து இறுதியாக இந்தப் பொறுப்புக்கு அவர் வருவதற்கு இடையில் கடந்துபோன காலம் 40 ஆண்டுகள்.
                வாரிசு அரசியல், குடும்ப அரசியல் என்று தி.மு.க-வின் மீது எதிர்க்கட்சிகள் தொடர்ந்து குற்றச்சாட்டு
                வைப்பதற்கு ஸ்டாலினின் அசாத்தியமான அரசியல் வளர்ச்சியும் ஒரு காரணம். ஆனால், எந்தப் பதவியையும் எளிதில்
                அடைந்துவிடவில்லை என்பது தி.மு.க-வின் மூத்த நிர்வாகிகளுக்கு நன்றாகத் தெரியும். ஸ்டாலினின் அரசியல்
                வளர்ச்சியை மிகவும் நிதானமாகவே கையாண்டார் கருணாநிதி. ஸ்டாலின் ஆரம்பித்த இளைஞர் அணி பதவி முதல் கட்சியின்
                பொருளாளர் பதவி வரை ஸ்டாலினைப் பலவிதங்களிலும் புடம்போட்டுப் படிப்படியாகவே பொறுப்புகளை வழங்கினார்
                கருணாநிதி. ஆனால், அவருடைய தலைவர் பதவியை தனயனுக்கு வழங்கியது மட்டும் கருணாநிதியின் முடிவாக இல்லை.
                காலத்தின் முடிவானது.
              </p>
              <div>
                <DfpAd adtype="test_new_1x1" placement="all" />
              </div>
              <p>
                2017-ம் ஆண்டு செயல் தலைவர் பதவியை அவர் பெற்றபோதுகூட அன்பழகன், கருணாநிதி இருவரின் ஒப்புதலும் அதில்
                இருந்தது. கருணாநிதியின்றி ஸ்டாலின் பெற்ற முதல் பதவி தி.மு.க தலைவர் பதவிதான்.
              </p>
              <div>
                <DfpAd adtype="test_300x250_3" placement="all" />
              </div>
              <p>
                தளபதியாக இருந்த ஸ்டாலின் தலைவராகப் பொறுப்பேற்றபோது 'மாற்றம்' இனி கட்சிக்குள் இருக்கும் என்ற
                எதிர்பார்ப்பும் ஏக்கமும் கட்சியின் கடைக்கோடித் தொண்டன் வரை இருந்தது. அந்த எதிர்பார்ப்பை
                நிறைவேற்றிவிட்டாரா ஸ்டாலின் என்று கேட்டால் இல்லை என்கிற பதிலை ஒரு சேரச் சொல்கிறார்கள் உடன்பிறப்புகள்.
                அதேநேரத்தில் அவரின் உழைப்பை, முயற்சியை யாரும் குறைசொல்லத் தயாராகவில்லை. ‘அரசியலில் உழைப்பு மட்டுமே
                உயர்வை கொடுத்துவிடாது, விவேகமும் சேர்ந்தே இருக்க வேண்டும். பல நேரங்களில் ஸ்டாலினின் விவேகம்
                வீணாகிவிடுகிறதே’ என்று பலரும் வேதனைப்படுகிறார்கள். கருணாநிதி காலத்தில் அவருடன் பயணம் செய்த பலரும்
                இப்போது ஸ்டாலின் காரிலும் பயணம் செய்கிறார்கள். இந்த வேதனையை வெளிப்படுத்துவதும் இவர்களே. காரும்,
                தலைமையும் மாறியதே தவிர இவர்கள் மாறவில்லை. மறைமுகமாகக் கட்சியில் ஆதிக்கம் செலுத்துவதும் ஆட்டுவிப்பதும்
                இவர்களே என்ற முணுமுணுப்பு அதிகமாகிக் கொண்டிருக்கிறது.{" "}
              </p>

              <div className={`${styles["suggested-tags"]}`}>
                <a href="javascript:void(0)">கருணாநிதி</a>
                <a href="javascript:void(0)">வரலாறு</a>
                <a href="javascript:void(0)">கடிதம்</a>
              </div>
              <Media query="(min-width:768px)">
                <DfpAd adtype="test_978x90" placement="all" />
              </Media>
            </div>
            <div>
              <DfpAd adtype="test_300x250" placement="all" />
              <br />
              <DfpAd adtype="test_300x600" placement="magazine-landing-page" />
              <div className={`${styles["trend-box"]}`}>
                <div className={`${styles["box-model-header"]}`}>
                  <h2 className={`${styles["box-header"]}`}>டிரெண்டிங் @ விகடன் </h2>
                </div>
                <div className={`${styles["box-model-content"]}`}>
                  <ul>
                    <li className={`${styles["flash-ticker-li"]}`}>
                      <div className={`${styles["trend-box"]}`}>
                        <div className={`${styles["flash-content"]}`}>
                          ஜெயலலிதா ஒதுக்கிய 44 கோடி ரூபாய் எங்கே? - கொந்தளிக்கும் வீராணம் பாசன விவசாயிகள்
                        </div>
                      </div>
                    </li>
                    <li className={`${styles["flash-ticker-li"]}`}>
                      <div className={`${styles["trend-box"]}`}>
                        <div className={`${styles["flash-content"]}`}>
                          ஜெயலலிதா ஒதுக்கிய 44 கோடி ரூபாய் எங்கே? - கொந்தளிக்கும் வீராணம் பாசன விவசாயிகள்
                        </div>
                      </div>
                    </li>
                    <li className={`${styles["flash-ticker-li"]}`}>
                      <div className={`${styles["trend-box"]}`}>
                        <div className={`${styles["flash-content"]}`}>
                          ஜெயலலிதா ஒதுக்கிய 44 கோடி ரூபாய் எங்கே? - கொந்தளிக்கும் வீராணம் பாசன விவசாயிகள்
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <DfpAd adtype="test_300x600" placement="magazine-landing-page" />
            </div>
          </div>
        </div>
        <div />
      </div>
    </div>
  );
};

export { StoryPageStatic };
